export function compareIssuingPolicy(idTokenClaims: any, policyToCompare: any) {
  let tfpMatches =
    idTokenClaims?.tfp &&
    idTokenClaims?.tfp?.toLowerCase() === policyToCompare?.toLowerCase();
  let acrMatches =
    idTokenClaims?.acr &&
    idTokenClaims?.acr?.toLowerCase() === policyToCompare?.toLowerCase();
  return tfpMatches || acrMatches;
}
